export default "__VITE_PUBLIC_ASSET__ce642098__"